import { freeze, assign } from 'icepick';
import {
	DELETE_COMPONENT_CONFIRMATION,
	DELETE_COMPONENT_CONFIRMED,
	DELETE_COMPONENT_SAFE,
	DELETE_COMPONENT_FAIL,
	CANCEL,
	type DeleteComponentSafeAction,
	type DeleteComponentConfirmationAction,
	type DeleteComponentConfirmedAction,
	type DeleteComponentFailAction,
	type CancelAction,
} from '../actions/delete.tsx';
import type { UiState } from './types.tsx';

type Action =
	| CancelAction
	| DeleteComponentConfirmationAction
	| DeleteComponentSafeAction
	| DeleteComponentFailAction
	| DeleteComponentConfirmedAction;

export const initialState: UiState = freeze({
	requiresConfirmation: false,
	deleteInProgress: false,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: UiState = initialState, action: Action): UiState => {
	switch (action.type) {
		case CANCEL: {
			return assign(state, {
				requiresConfirmation: false,
				deleteInProgress: false,
			});
		}

		case DELETE_COMPONENT_FAIL: {
			return assign(state, {
				deleteInProgress: false,
			});
		}

		case DELETE_COMPONENT_SAFE:
		case DELETE_COMPONENT_CONFIRMED: {
			return assign(state, {
				deleteInProgress: true,
			});
		}

		case DELETE_COMPONENT_CONFIRMATION: {
			return assign(state, {
				requiresConfirmation: true,
			});
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
